// Single localization path for the payroll country-dropdown option label. Builds the label
// directly from the global translation dict (country name + payroll-status suffix) so the
// suffix is never left in English. The prewarmed cache holds both the country names and the
// two suffix phrases for every language.
export function formatCountryOption(c, dict) {
  const name = (dict && dict[c.name]) || c.name;
  const key = c.verified ? "Payroll supported" : "Payroll coming soon";
  const suffix = (dict && dict[key]) || key;
  return `${name} — ${suffix}`;
}
